export const voiceCalls = {
  "head": {
    "title": "المكالمات",
    "subtitle": "المكالمات التي ردّ عليها استقبالك الهاتفي."
  },
  "stats": {
    "all": "مكالمة | مكالمات",
    "spoken": "مردود عليها | مردود عليها",
    "inTotal": "في المجموع"
  },
  "toolbar": {
    "searchLabel": "بحث",
    "searchPlaceholder": "رقم المتصل…",
    "clear": "مسح البحث",
    "showLabel": "عرض",
    "showAll": "كل المكالمات",
    "showSpoken": "المردود عليها فقط",
    "showRecorded": "المسجّلة فقط"
  },
  "notice": {
    "noRecording": "لا يتم تسجيل المكالمات.",
    "noRecordingHow": "فعّل «تسجيل المكالمات» في إعدادات الاستقبال الهاتفي، وعندها ستتمكن من الاستماع إليها وتفريغها من هنا."
  },
  "empty": {
    "title": "لم يتصل بك أحد بعد",
    "text": "عندما يتصل أحد برقم الاستقبال، ستظهر المكالمة هنا مع اسم المتصل ومدتها وما أراده.",
    "filteredTitle": "لا توجد مكالمات بهذا الفلتر",
    "filteredText": "جرّب إزالة البحث أو الفلاتر أعلاه."
  },
  "item": {
    "notSpoken": "لم يتحدثا",
    "unknownCaller": "رقم مخفي",
    "linkSent": "تم إرسال رابط الحجز",
    "play": "تشغيل التسجيل",
    "pause": "إيقاف مؤقت",
    "showTranscript": "عرض النص",
    "hideTranscript": "إخفاء النص",
    "transcribe": "تفريغ وتلخيص",
    "transcribing": "جارٍ التفريغ…",
    "noRecordingShort": "لم يتم تسجيل هذه المكالمة",
    "viewReservation": "عرض الحجز",
    "noSummary": "لا يوجد ملخّص لهذه المكالمة.",
    "copy": "نسخ الرقم",
    "copied": "تم النسخ"
  },
  "errors": {
    "load": "تعذّر تحميل المكالمات.",
    "play": "تعذّر تشغيل التسجيل.",
    "transcribe": "تعذّر طلب التفريغ."
  },
  "table": {
    "call": "المكالمة",
    "reservation": "الحجز",
    "listing": "مكان الإقامة",
    "summary": "الملخّص",
    "duration": "المدة",
    "date": "التاريخ"
  }
};
